/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Insert_ButtonInputs */

const en_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Speaker`)
};

const fr_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer le locuteur`)
};

const de_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecher einbauen`)
};

const it_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci altoparlante`)
};

const ru_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить динамик`)
};

const es_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar altavoz`)
};

const zh_cn2_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入扬声器`)
};

const ja_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを挿入`)
};

const hi_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर डालें`)
};

const pt_pt2_insert_speaker_insert_button = /** @type {(inputs: Insert_Speaker_Insert_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alto-falante de inserção`)
};

/**
* | output |
* | --- |
* | "Insert Speaker" |
*
* @param {Insert_Speaker_Insert_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_insert_button = /** @type {((inputs?: Insert_Speaker_Insert_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Insert_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_insert_button(inputs)
	if (locale === "de") return de_insert_speaker_insert_button(inputs)
	if (locale === "it") return it_insert_speaker_insert_button(inputs)
	if (locale === "ru") return ru_insert_speaker_insert_button(inputs)
	if (locale === "es") return es_insert_speaker_insert_button(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_insert_button(inputs)
	if (locale === "ja") return ja_insert_speaker_insert_button(inputs)
	if (locale === "hi") return hi_insert_speaker_insert_button(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_insert_button(inputs)
	return en_insert_speaker_insert_button(inputs)
});